/**
 * App Pages
 */

import { IPage } from "./Interfaces";
import Home from "../../pages/Home"
import Dashboard from "../../pages/Panel/Dashboard";
import Login from "../../pages/Login";
import Logout from "../../pages/Logout";
import AdminBasePage from "../admin/AdminBasePage";
import SetPassword from "../../pages/SetPassword";
import Register from "../../pages/Register";
import ResetPassword from "../../pages/ResetPassword";
import BlockAccount from "../../pages/BlockAccount";
import UnblockAccount from "../../pages/UnblockAccount";
import Profile from "../../pages/Profile";
import NonePage from "./NonePage";
import NothingFoundPage from "../../pages/NothingFoundPage";
import Warehouses from "../../pages/Warehouses";
import Inventory from "../../pages/Inventory";
import Warehouse from "../../pages/Warehouse";
import SingleItem from "../../pages/SingleItem";
import ContainerQrCodesPage from "../items/ContainerQrCodesPage";
import ViewRequestPage from "../items_requests/ViewRequestPage";
import MyRequests from "../items_requests/MyRequests";
import NewRequestStaffPage from "../items_requests/NewRequestStaffPage";

export const appPages: Array<IPage> = [
    {
        name: "home",
        title: "Home",
        // component: Warehouses,
        component: Inventory,
        path: "/",
        isProtected: false
    },
    // {
    //     name: "dashboard",
    //     title: "Dashboard",
    //     component: Dashboard,
    //     path: "/panel/dashboard",
    //     isProtected: true,
    //     isAdminOnly: true
    // },
    {
        name: "login",
        title: "Sign-in",
        component: Login,
        path: "/sign-in"
    },
    {
        name: "set-password",
        title: "Register",
        component: SetPassword,
        path: "/set-password/:token"
    },
    {
        name: "set-password-new-link",
        title: "Register",
        component: SetPassword,
        path: "/set-password"
    },
    {
        name: "new-forgot-password-link",
        title: "Update Password",
        component: ResetPassword,
        path: "/reset-password/:token"
    },
    {
        name: "forgot-password",
        title: "Forgot Password",
        component: ResetPassword,
        path: "/forgot-password"
    },
    {
        name: "sign-up",
        title: "Register",
        component: Register,
        path: "/sign-up"
    },
    {
        name: "block-account",
        title: "Block Account",
        component: BlockAccount,
        path: "/block-account"
    },
    {
        name: "request-unblock-account",
        title: "Unblock Account",
        component: UnblockAccount,
        path: "/unblock-account"
    },
    {
        name: "unblock-account",
        title: "Unblock Account",
        component: UnblockAccount,
        path: "/unblock-account/:token"
    },
    {
        name: "profile",
        title: "Profile",
        component: Profile,
        path: "/profile",
        isProtected: true,
    },
    {
        name: "profile-section",
        title: "Profile",
        component: Profile,
        path: "/profile/:section",
        isProtected: true,
    },
    {
        name: "logout",
        title: "Sign-out",
        component: Logout,
        path: "/logout"
    },
    /**
     * Warehouse
     */
    {
        name: "warehouses",
        title: "Warehouses",
        component: Warehouses,
        path: "/warehouses",
        isProtected: false,
    },
    {
        name: "warehouse",
        title: "Warehouse",
        component: Warehouse,
        path: "/warehouses/:id",
        isProtected: true,
    },
    /**
     * Inventory
     */
    {
        name: "inventory",
        title: "Inventory",
        component: Inventory,
        path: "/items",
        isProtected: false,
    },
    {
        name: "single-item",
        title: "Item",
        component: SingleItem,
        path: "/items/:unique_id",
        isProtected: false,
    },
    /**
     * Admin Pages
     */
    {
        name: "admin-panel-base-page",
        title: "Base Page",
        component: AdminBasePage,
        path: "/panel/:page_name",
        isProtected: true,
        isAdminOnly: true
    },
    {
        name: "admin-panel-edit-page",
        title: "Base Page",
        component: AdminBasePage,
        path: "/panel/:page_name/edit/:id",
        isProtected: true,
        isAdminOnly: true
    },
    {
        name: "admin-panel-view-page",
        title: "Base Page",
        component: AdminBasePage,
        path: "/panel/:page_name/view/:id",
        isProtected: true,
        isAdminOnly: true
    },
    {
        name: "admin-panel-new-page",
        title: "Base Page",
        component: AdminBasePage,
        path: "/panel/:page_name/new",
        isProtected: true,
        isAdminOnly: true
    },
    /**
     * Print Pages
     */
    {
        name: "container-item-qr-codes",
        title: "QR Codes",
        component: ContainerQrCodesPage,
        path: "/print/items/qr-codes/:unique_id",
        isProtected: true,
    },
    /**
     * Requests
     */
    {
        name: "my-requests",
        title: "My Requests",
        component: MyRequests,
        path: "/requests",
        isProtected: true,
    },
    {
        name: "new-item-request",
        title: "Request",
        component: NewRequestStaffPage,
        path: "/requests/new",
        isProtected: true,
    },
    {
        name: "view-single-request",
        title: "Request",
        component: ViewRequestPage,
        path: "/requests/:request_number",
        isProtected: true,
    },
    /**
     * 404 Page
     */
    {
        name: "nothing-found-404",
        title: "Nothing Found",
        component: NothingFoundPage,
        path: "*",
    },
]

export const returnRouterPage = (name: string) => {

    let page: IPage =  {
        name: "",
        title: "",
        component: NonePage,
        path: "/",
    }

    if (appPages.length > 0){
        appPages.map((singlePage) => {
            if (singlePage.name === name){
                page = singlePage
            }
        })
    }

    return page
}